import Messages from "../models/Messages";

const MessagesStore = Messages.create({ selectedGroup: {} });

export default MessagesStore;
